const first = [
  {
    Product: "Brown faux fur longline coat",
    Price: "$190",
    Singlelines:
      "Sed egestas, ante et vulputate volutpat, eros pede semper est, vitae luctus metus libero eu augue. Morbi purus libero, faucibus adipiscing. Sed lectus. ",
    Dec: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. Nullam malesuada erat ut turpis. Suspendisse urna viverra non, semper suscipit, posuere a, pede. Donec nec justo eget felis facilisis fermentum. Aliquam porttitor mauris sit amet orci.",
  },
];

const second = [
  {
    Product: "CAVALLO by Linen Club Red Printed Regular Fit Casual Shirt",
    Price: "₹1,079",
    Singlelines:
      "Care Instructions: Machine Wash Fit Type: Regular Fit Discover your most impressive self with the finest Linen fabrics that are made for the truly different. Linen Is used from Pre Historic times. Linen is a natural fabric produced from fibres of the flax plant. Ancient Egyptians believed that linen was a gift of the God. It symbolized cleanliness and purity. Linen Club - Largest Producer of Pure Linen Fabric In India Linen allows the skin to breathe, and is extremely comfortable under all weather conditions. 100% Natural, anti bacterial and UV protective Linen is fully biodegradable and is now commonly recycled",
    // img1: "assets/images/products/single/sticky/1.jpg",
    img1: "https://m.media-amazon.com/images/I/51ycxeaHh8L._UL1500_.jpg",
    img2: "https://m.media-amazon.com/images/I/61s4D0HGiFL._UL1500_.jpg",
    img3: "https://m.media-amazon.com/images/I/617JnvK0YRL._UL1500_.jpg",
    img4: "https://m.media-amazon.com/images/I/81Djez5UCLL._UL1500_.jpg",
  },
];
const three = [
  {
    Product: "Linen Club Yellow Casual Shirts Regular Fit Linen Shirt for Men",
    Price: "₹2,599",
    Singlelines:
      "Care Instructions: Machine Wash Fit Type: Regular Fit Fabric: Premium Blended Linen",
    Dec: "Care Instructions: Machine Wash Fit Type: Regular Fit    ",
    img1: "",
    img2: "https://m.media-amazon.com/images/I/61VlCD-XGRL._UL1500_.jpg",
    img3: "https://m.media-amazon.com/images/I/51iHQY4VZLL._UL1500_.jpg",
    img4: "https://m.media-amazon.com/images/I/51ow0f1HFaL._UL1500_.jpg",
  },
];
const bluejacketwomen = [
  {
    Product: "FUNDAY FASHION Full Sleeve Blue Solid Women's Denim Jacket",
    Price: "₹345",
    Oldprice: "₹1,499",
    img1: "assets/images/Productimg/3-1.jpg",
    img2: "assets/images/Productimg/3-2.jpg",
    img3: "assets/images/Productimg/3-3.jpg",
    img4: "assets/images/Productimg/3-4.jpg",
  },
];
const batawomenblackheels = [
  {
    Product: "BATA Women TRICIA SANDAL Black Heels, (7616683)",
    Price: "₹863",
    Oldprice: "₹1,199",
    img1: "assets/images/Productimg/2-1.jpg",
    img2: "assets/images/Productimg/2-2.jpg",
    img3: "assets/images/Productimg/2-3.jpg",
    img4: "assets/images/Productimg/2-4.jpg",
  },
];
const Printedsweatshirtunisexstyles = [
  {
    Product:
      "ELLITI Men & Women Cotton Unisex Stylish Latest Printed Pullover Cotton Hooded Hoodies Sweatshirt",
    Price: "₹999",
    Oldprice: "₹3,999",
    img1: "assets/images/Productimg/1-1.jpg",
    img2: "assets/images/Productimg/1-2.jpg",
    img3: "assets/images/Productimg/1-3.jpg",
    img4: "assets/images/Productimg/1-4.jpg",
  },
];
const cigaretteTrouse = [
  {
    Product: "PANIT Solid Rose Gold elsticated high Waist Cigarette Trouser  ",
    Price: "₹499",
    Oldprice: "₹,,399",
    img1: "assets/images/Productimg/4-1.jpg",
    img2: "assets/images/Productimg/4-2.jpg",
    img3: "assets/images/Productimg/4-3.jpg",
    img4: "assets/images/Productimg/4-4.jpg",
  },
];
const sleeveszipperjacket = [
  {
    Product: "ADBUCKS Rich Cotton Full Sleeves Zipper Jacket with Hoodies for Boys",
    Price: "₹649",
    Oldprice: "₹,,499",
    img1: "assets/images/Productimg/5-1.jpg",
    img2: "assets/images/Productimg/5-2.jpg",
    img3: "assets/images/Productimg/5-3.jpg",
    img4: "assets/images/Productimg/5-4.jpg",
  },
];
export {
  first,
  second,
  three,
  bluejacketwomen,
  batawomenblackheels,
  Printedsweatshirtunisexstyles,
  cigaretteTrouse,
  sleeveszipperjacket,
};
